export default (opt) => {
  return Array.prototype.slice.call(opt, 0)
}